import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { appConfig } from './app.config';
import { environment } from './environments/environment';

if (environment.production) {
    console.log = () => { };
    console.debug = () => { };
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
